<template>
	<div class="min-h-[calc(100lvh-20rem)] grid place-items-center">
		<div>
			<div class="font-poppins text-2xl">Loading</div>
			<loader />
		</div>
	</div>
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue'

export default defineComponent({
	setup(props) {
		return {}
	},
})
</script>
